import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "rcontainer"
};
const _hoisted_2 = {
  class: "listTop"
};
const _hoisted_3 = {
  key: 0,
  class: "typeSlide"
};
const _hoisted_4 = {
  class: "swiper-container swiperbox",
  ref: "swipercontainer"
};
const _hoisted_5 = {
  class: "swiper-wrapper"
};
const _hoisted_6 = ["onClick"];
const _hoisted_7 = {
  class: "swiper-button-next",
  ref: "swiperbuttonnext"
};
const _hoisted_8 = {
  class: "swiper-button-prev",
  ref: "swiperbuttonprev"
};
const _hoisted_9 = {
  key: 0
};
const _hoisted_10 = ["onClick"];
const _hoisted_11 = {
  class: "txtbox"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_CloseBold = _resolveComponent("CloseBold");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_ArrowRightBold = _resolveComponent("ArrowRightBold");
  const _component_ArrowLeftBold = _resolveComponent("ArrowLeftBold");
  const _component_el_empty = _resolveComponent("el-empty");
  return _openBlock(), _createElementBlock(_Fragment, null, [$props.style.routebutton === 1 ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "routebutton",
    style: _normalizeStyle($options.getrouteBtnstyle($props.style)),
    onClick: _cache[0] || (_cache[0] = (...args) => $options.routebtnHandle && $options.routebtnHandle(...args))
  }, _toDisplayString($props.style.routebuttontext), 5)) : _createCommentVNode("", true), _createElementVNode("div", {
    class: _normalizeClass(["routelistWrap", [{
      'on': $data.showlistflag
    }, {
      'mobile': $props.isMobile
    }, {
      'useSvw': $props.id === 1
    }]])
  }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[1] || (_cache[1] = _createElementVNode("h4", null, "路线信息", -1)), _createVNode(_component_el_icon, {
    onClick: $options.closeroutelist
  }, {
    default: _withCtx(() => [_createVNode(_component_CloseBold)]),
    _: 1
  }, 8, ["onClick"])]), $props.typelist.length > 1 ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.typelist, (item, i) => {
    return _openBlock(), _createElementBlock("div", {
      class: "swiper-slide",
      key: i
    }, [_createElementVNode("h4", {
      class: _normalizeClass({
        'active': $data.tIndex === i
      }),
      onClick: _withModifiers($event => $options.typeClick(item, i), ["stop"])
    }, _toDisplayString(item.itemformdata.title), 11, _hoisted_6)]);
  }), 128))])], 512), _createElementVNode("div", _hoisted_7, [_createVNode(_component_el_icon, null, {
    default: _withCtx(() => [_createVNode(_component_ArrowRightBold)]),
    _: 1
  })], 512), _createElementVNode("div", _hoisted_8, [_createVNode(_component_el_icon, null, {
    default: _withCtx(() => [_createVNode(_component_ArrowLeftBold)]),
    _: 1
  })], 512)])) : _createCommentVNode("", true), _createElementVNode("div", {
    class: _normalizeClass(["routelist", {
      'notop': $props.typelist.length <= 1
    }])
  }, [$data.dataList.length > 0 ? (_openBlock(), _createElementBlock("ul", _hoisted_9, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.dataList, (item, i) => {
    return _openBlock(), _createElementBlock("li", {
      class: _normalizeClass({
        'active': $data.rIndex === item.id
      }),
      key: i,
      onClick: $event => $options.routeClick(item)
    }, [_createElementVNode("h4", null, _toDisplayString(item.itemformdata.title), 1), _createElementVNode("div", _hoisted_11, [_cache[3] || (_cache[3] = _createElementVNode("label", null, "途经：", -1)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.getPoint(item.itemformdata.jsontxt), (child, ids) => {
      return _openBlock(), _createElementBlock("span", {
        key: ids
      }, [child ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createTextVNode(_toDisplayString(child.itemformdata.place_name), 1)], 64)) : _createCommentVNode("", true), _cache[2] || (_cache[2] = _createElementVNode("i", {
        class: "icon-guide-arrow-right"
      }, null, -1))]);
    }), 128))])], 10, _hoisted_10);
  }), 128))])) : _createCommentVNode("", true), $data.dataList.length === 0 ? (_openBlock(), _createBlock(_component_el_empty, {
    key: 1,
    "image-size": 100,
    description: "暂无数据"
  })) : _createCommentVNode("", true)], 2)])], 2)], 64);
}